import legacyToolRoutes from '../config/legacy-tool-routes.json';

export function resolveLegacyToolPath(value: unknown): string {
  const tool = Array.isArray(value) ? value[0] : value;
  if (typeof tool !== 'string') return '/';

  return legacyToolRoutes[tool as keyof typeof legacyToolRoutes] ?? '/';
}
